export const STRIPE_BILLING_LOGIN_URL =
  "https://billing.stripe.com/p/login/14k6pgfpBbVTcW4bII";
